import { useEffect } from 'react';
import { strToBase64 } from './base64';

export * from './base64';

export const useObfuscation = (
  ref: any,
  href?: string,
  navigate?: (url: string) => void,
) => {
  useEffect(() => {
    const elt = ref?.current;
    //fonction du click gauche
    const onClickLeft = (event: any) => {
      const attribute = elt.getAttribute('data-qcd');
      const blank = elt.getAttribute('data-target') !== 'false';

      if (event.shiftKey || event.ctrlKey || event.metaKey || blank) {
        const newWindow = window.open(
          decodeURIComponent(window.atob(attribute)),
          '_blank',
        );

        if (event.shiftKey) {
          newWindow?.focus();
        }
      } else {
        const url = decodeURIComponent(window.atob(attribute));
        if (navigate) {
          navigate(url);
        } else document.location.href = url;
      }
    };

    //fonction du click droit
    const onClickRight = (event: any) => {
      const attribute = elt.getAttribute('data-qcd');

      if (event.shiftKey || event.ctrlKey || event.metaKey) {
        const newWindow = window.open(
          decodeURIComponent(window.atob(attribute)),
          '_blank',
        );

        if (event.shiftKey) {
          newWindow?.focus();
        }
      } else {
        window.open(decodeURIComponent(window.atob(attribute)), '_blank');
      }
    };

    if (href) {
      elt?.setAttribute('data-qcd', strToBase64(href));
      //click gauche
      elt?.addEventListener('click', onClickLeft, false);
      //click droit
      elt?.addEventListener('contextmenu', onClickRight, false);
    }

    return () => {
      if (href) {
        elt?.removeEventListener('click', onClickRight);
        elt?.removeEventListener('click', onClickLeft);
        elt?.removeEventListener('contextmenu', onClickRight);
      }
    };
  }, [href, navigate, ref]);
};
